import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../components/context/AppContext';
import axiosInstance from '../axios';
import LoadingCard from './LoadingCard';
import { safeLocalStorage } from './safeStorage';

const AuthProvider = ({ children }) => {
  const { user, setUser } = useAppContext();
  const [loading, setLoading] = useState(true); // Indicates whether authentication is in progress
  const navigate = useNavigate();
  console.log("in auth provider");
  console.log(user);

  useEffect(() => {
    const checkUserAuth = async () => {
      try {
        const token = safeLocalStorage.getItem('token'); // Check if token exists
        if (token) {
          const response = await axiosInstance.get('/api/user/get');
          if (response.data.success) {
            setUser(response.data.data.user);
            if(window.location.pathname === '/login') navigate('/');
          } else {
            if (response.status === 401 || response.status === 403) {
              safeLocalStorage.removeItem('token'); // Clear invalid token
              setUser(null);
              navigate('/login', { state: { message: response?.data?.message } });
            }
          }
        } else {
          setUser(null); // No token, user is unauthenticated
        }
      } catch (err) {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
            safeLocalStorage.removeItem('token');
            setUser(null);
            navigate('/login', { state: { message: 'Please Login!' } });
        } else {
            // Network error - keep user logged in, will retry on next navigation
            console.error('Auth check failed:', err.message);
        }
      } finally {
        setLoading(false); // Authentication check completed
      }
    };

    checkUserAuth();
  }, [setUser, navigate]);

  // Render a loading spinner until user authentication is resolved
  if (loading) {
    return <LoadingCard/>;
  }

  return <>{children}</>;
};

export default AuthProvider;
